<payee-popup
  class="edit-case-popup"
  width="900px"
  maxWidth="80vw"
>
  <ng-template #payeePopupTitleTemplate>
    <h1>Ügy szerkesztése</h1>
  </ng-template>

  @if (!initialized()) {
    <mat-progress-spinner
      mode="indeterminate"
      color="accent"
      style="margin: auto"
    ></mat-progress-spinner>
  }

  @if (initialized()) {
    <div
      class="form-content"
      [class.is-submitting]="submitting()"
      [attr.aria-busy]="submitting()"
    >
      <mat-accordion
        displayMode="flat"
        multi
      >
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header [class.invalid]="legal_relationship.invalid">
            <mat-panel-title>
              Jogviszony
              @if (isLegalRelationshipGenerateComplete) {
                <payee-icon
                  name="checkmark-green-circle"
                  width="18px"
                  height="18px"
                ></payee-icon>
              }
              @if (hasAiFilledIn(legal_relationship)) {
                <span
                  class="ai-badge"
                  title="AI által kitöltve"
                >
                  AI
                </span>
              }
            </mat-panel-title>
            <mat-panel-description>
              @if (isLegalRelationshipGenerateComplete) {
                @if (legalRelationship()) {
                  <span>{{ legalRelationship() }}</span>
                }
                @if (legalRelationshipSpecification) {
                  <span>
                    {{ legalRelationshipSpecification }}
                  </span>
                }
              } @else {
                <span class="missing-fields">Hiányzik: {{ legalRelationshipMissing() }}</span>
              }
            </mat-panel-description>
          </mat-expansion-panel-header>
          <app-case-form></app-case-form>
          <app-attorney-form></app-attorney-form>
          <app-external-ids-form></app-external-ids-form>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header [class.invalid]="claims.invalid">
            <mat-panel-title>
              Követelések
              @if (isClaimsGenerateComplete) {
                <payee-icon
                  name="checkmark-green-circle"
                  width="18px"
                  height="18px"
                ></payee-icon>
              }
              @if (hasAiFilledIn(claims)) {
                <span
                  class="ai-badge"
                  title="AI által kitöltve"
                >
                  AI
                </span>
              }
            </mat-panel-title>
            <mat-panel-description>
              @if (isClaimsGenerateComplete) {
                <span>{{ claims.length }} db</span>
              } @else {
                <span class="missing-fields">Hiányzik: {{ claimsMissing() }}</span>
              }
            </mat-panel-description>
          </mat-expansion-panel-header>
          <app-claims-form></app-claims-form>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header [class.invalid]="client.invalid">
            <mat-panel-title>
              Hitelező
              @if (isClientGenerateComplete) {
                <payee-icon
                  name="checkmark-green-circle"
                  width="18px"
                  height="18px"
                ></payee-icon>
              }
              @if (isClientDuplicated) {
                <span
                  class="duplicate-badge"
                  title="Duplikált hitelező"
                >
                  Duplikált
                </span>
              }
              @if (hasAiFilledIn(client)) {
                <span
                  class="ai-badge"
                  title="AI által kitöltve"
                >
                  AI
                </span>
              }
            </mat-panel-title>
            <mat-panel-description>
              @if (isClientGenerateComplete) {
                @if (clientName) {
                  <span>{{ clientName }}</span>
                }
              } @else {
                <span class="missing-fields">Hiányzik: {{ clientMissing() }}</span>
              }
            </mat-panel-description>
          </mat-expansion-panel-header>
          <app-client-form></app-client-form>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header [class.invalid]="debtors.invalid">
            <mat-panel-title>
              Adós
              @if (isDebtorsGenerateComplete) {
                <payee-icon
                  name="checkmark-green-circle"
                  width="18px"
                  height="18px"
                ></payee-icon>
              }
              @if (hasAiFilledIn(debtors)) {
                <span
                  class="ai-badge"
                  title="AI által kitöltve"
                >
                  AI
                </span>
              }
            </mat-panel-title>
            <mat-panel-description>
              @if (isDebtorsGenerateComplete) {
                @if (debtorName) {
                  <span>{{ debtorName }}</span>
                }
              } @else {
                <span class="missing-fields">Hiányzik: {{ debtorsMissing() }}</span>
              }
            </mat-panel-description>
          </mat-expansion-panel-header>
          <app-debtors-form></app-debtors-form>
        </mat-expansion-panel>
      </mat-accordion>

      @if (submitting()) {
        <div class="submitting-overlay">
          <mat-progress-spinner
            mode="indeterminate"
            color="accent"
          ></mat-progress-spinner>
        </div>
      }
    </div>
  }

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="wide"
      [loading]="submitting()"
      [disabled]="submitting()"
      (click)="submit()"
    >
      Mentés
    </button>
  </ng-template>
  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="alert-red"
      width="wide"
      [disabled]="submitting()"
      (click)="cancel()"
    >
      Bezárás
    </button>
  </ng-template>
</payee-popup>
